import { createStyles, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'

const styles = () =>
  createStyles({
    separator: {
      width: '100%',
      minHeight: 1,
      backgroundColor: '#dee2eb',
    },
  })

interface ISeparator extends WithStyles {
  className?: string
}
export const Separator = withStyles(styles)(({ className, classes }: ISeparator) => (
  <div className={className || classes.separator} />
))
